import React from 'react'
import PropTypes from 'prop-types'

const CaseStudyBasicInfo = (props) => {
    return (
        <div className="content basic-info">
            <div className="content-image basic-info">
                <img src={props.imageurl} />
            </div>
            <div className="content-text basic-info">
                <h4>{props.title}</h4>
                <p>{props.body}</p>
            </div>
        </div>
    )
}

export default CaseStudyBasicInfo

CaseStudyBasicInfo.propTypes = {
    imageurl: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    body: PropTypes.string.isRequired
}